import intValidator from './intValidator';

export default { intValidator }
